import React, { useState, useEffect } from 'react';
import {
  Col,
  Row,
} from 'react-bootstrap';
import {
  SucursalReportes,
  DesgloseReport,
  MasterGuias,
  MasterTotales,
  Manifiesto,
  ManifiestoEstado,
  DesgloseBolReport,
} from './views/general.reports';


const Reportes = () => {

  const [reporte, setReporte] = useState(false);
  const [option, setOption] = useState(true);

  const reporteSelected = (report) => {
    setReporte(report);
  }

  useEffect(() => {
    if (reporte) {
      setOption(false);
    }
  },[reporte]);

  useEffect(() => {
    if (option) {
      setReporte(false);
    }
  },[option]);

  return (
    <>
    <div className="mb-2">
      <h4>Reportes</h4>
    </div>
    {option ?
    <>
      <Row>
    
        <Col>
          <div onClick={() => reporteSelected(7)} className="box-option-reports">
              <h1>Recibo de pagos</h1>
          </div>
        </Col>
        <Col>
          <div onClick={() => reporteSelected(3)} className="box-option-reports">
              <h1>Desglose guia master</h1>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <div onClick={() => reporteSelected(4)} className="box-option-reports">
              <h1>Guias master totales en pesos y pies cubicos</h1>
          </div>
        </Col>
        <Col>
          <div onClick={() => reporteSelected(5)} className="box-option-reports">
              <h1>Manifiesto de cargas</h1>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div onClick={() => reporteSelected(6)} className="box-option-reports">
              <h1>Manifiesto por estados destino</h1>
          </div>
        </Col>
      </Row>
    </>
    : null}

    {!option ?  
    <Row>
      <Col>
        <div className="back-button-reports">
              <button
                  onClick={() => setOption(true)}
                  type="button"
                  className="btnx btnx-warn mr-2"
              >
                  Regresar al listado
              </button> 
        </div>
      </Col>
    </Row>
    : null}

    { reporte === 1? 
        <DesgloseReport />
      : reporte === 2 ?
        <SucursalReportes />
      :reporte === 3 ?
        <MasterGuias />
      :reporte === 4 ?
        <MasterTotales />
      :reporte === 5 ?
        <Manifiesto />
      :reporte === 6 ?
        <ManifiestoEstado />
      :reporte === 7 ?
        <DesgloseBolReport />
      : null
    }
    </>
  )
}

export default Reportes;